import React from 'react'
import PropTypes from 'prop-types'
import {
  StyledContainer,
  StyledStepLabel,
  StyledStepWrapper,
  StyledCheckStepContent,
} from './styles'
import { Box } from '../../atoms/box'
import { Flex } from '../../atoms/flex'
import { Image } from '../../atoms/image'
import { Text } from '../../atoms/text'
import TickedIcon from '../../../images/refer-a-friend/icon_playerstatus_tick.svg'
import UntickedIcon from '../../../images/refer-a-friend/icon_playerstatus_unticked.svg'
import useDeviceDetect from '../../../hooks/useDeviceDetect'

export const Steps = ({ steps, theme, backgroundContent, currentStep }) => {
  const { isMobile } = useDeviceDetect()

  if (theme === 'check') {
    return (
      <StyledContainer direction="horizontal" noMargin noPadding>
        {steps?.map((item, index) => (
          <StyledCheckStepContent key={item}>
            <Box
              padding="0 1em"
              background={backgroundContent}
              style={{ position: 'relative', zIndex: 3 }}
            >
              <Flex direction="column" gap="0.25" alignItems="center">
                <Image
                  url={index <= currentStep ? TickedIcon : UntickedIcon}
                  width={32}
                />
                <Text textAlign="center" small={isMobile}>
                  {item}
                </Text>
              </Flex>
            </Box>
          </StyledCheckStepContent>
        ))}
      </StyledContainer>
    )
  }

  return (
    <StyledContainer>
      {steps?.map((item, index) => (
        <StyledStepWrapper key={item}>
          <StyledStepLabel>{index + 1}</StyledStepLabel>
          <Text style={{ paddingRight: isMobile ? null : 40 }}>{item}</Text>
        </StyledStepWrapper>
      ))}
    </StyledContainer>
  )
}

Steps.defaultProps = {
  steps: [],
  theme: 'default',
  backgroundContent: null,
  currentStep: null,
}

Steps.propTypes = {
  steps: PropTypes.array,
  theme: PropTypes.string,
  backgroundContent: PropTypes.string,
  currentStep: PropTypes.number,
}
